import { get } from 'lodash'

export function isEnableEssentialApps () {
  return get(window.newBillingConfig, 'enableEssentialApp', false) || get(window.newBillingConfig, 'enableBillingEssentialApp', false);
}